import { buildAgreementsPayloadFromFilter } from '../../../agreements/utils/agreements-filter-payload.builder';
import { readDwtDefraSubmissionsTaskPaneFilterFromDom } from '../../../dwt-defra-submissions';
import { buildDwtDefraSubmissionsPayloadFromFilter } from '../../../dwt-defra-submissions/utils/dwt-defra-submissions-filter-payload.builder';
import { readDwtPayloadsTaskPaneFilterFromDom } from '../../../dwt-payloads';
import { buildDwtPayloadsPayloadFromFilter } from '../../../dwt-payloads/utils/dwt-payloads-filter-payload.builder';
import { buildMaterialSummaryFilterFromTaskPaneRead } from '../../../material-summary/utils/build-material-summary-payload.util';
import { readMaterialSummaryTaskPaneFilterFromDom } from '../../../material-summary/utils/read-material-summary-task-pane-filter.util';
import { resolveAddinOperatingOrgCode } from '../../../organisations/resolve-addin-operating-org-code.util';
import { readAgreementsTaskPaneFilterFromDom } from '../../report-input/read-agreements-taskpane-filter.util';
import {
    REPORT_TARGET_AGREEMENTS_VALUE,
    REPORT_TARGET_DWT_DEFRA_SUBMISSIONS_VALUE,
    REPORT_TARGET_DWT_PAYLOADS_VALUE,
    REPORT_TARGET_MATERIAL_SUMMARY_VALUE,
} from '../../taskpane.constants';
import { stableFingerprintString } from './stable-json-fingerprint.util';

/**
 * Builds a session-stable fingerprint for the current DOM filter state + reporting target + org code.
 * Matches the normalized filter objects sent to the Activity Handler (same builders as fetch).
 */
export function buildTraceFetchFingerprintString(targetId: string): string | null {
    const orgCode = resolveAddinOperatingOrgCode().trim().toLowerCase();
    let filter: unknown;
    switch (targetId) {
        case REPORT_TARGET_AGREEMENTS_VALUE: {
            const domFilter = readAgreementsTaskPaneFilterFromDom();
            filter = buildAgreementsPayloadFromFilter(domFilter).data.filter;
            break;
        }
        case REPORT_TARGET_MATERIAL_SUMMARY_VALUE: {
            const read = readMaterialSummaryTaskPaneFilterFromDom();
            filter = buildMaterialSummaryFilterFromTaskPaneRead(read);
            break;
        }
        case REPORT_TARGET_DWT_PAYLOADS_VALUE: {
            const read = readDwtPayloadsTaskPaneFilterFromDom();
            filter = buildDwtPayloadsPayloadFromFilter(read).data.filters;
            break;
        }
        case REPORT_TARGET_DWT_DEFRA_SUBMISSIONS_VALUE: {
            const read = readDwtDefraSubmissionsTaskPaneFilterFromDom();
            filter = buildDwtDefraSubmissionsPayloadFromFilter(read).data.filters;
            break;
        }
        default:
            return null;
    }
    return stableFingerprintString({ targetId, orgCode, filter });
}
